export const PUBLIC_URL_ROOT = 'https://tophouse.com';
export const RETOOL_USERS_APP = `https://tophouse.retool.com/apps/3d99656a-997c-11ec-b7e7-a35572345817/%F0%9F%99%8B%F0%9F%8F%BB%E2%80%8D%E2%99%80%EF%B8%8F%20Users`;
